/**
 * Created by m.igrachev on 7/20/2017.
 */
export default function objectWithout(object, without) {
    let result = {};

    for (let prop in object) {
        if (!object.hasOwnProperty(prop)) continue;
        if (without.indexOf(prop) < 0) {
            result[prop] = object[prop];
        }
    }
    return result;
}
